var map = {
	"./01_Aparthied .png": 9823,
	"./02_Before the invasion.png": 8905,
	"./03_conversation.png": 1400,
	"./04_Find Truth.png": 1610,
	"./05_Forest living.png": 7093,
	"./06_Full Talk.png": 4883,
	"./07_Harsh truth.png": 1942,
	"./08_New look_.png": 7756,
	"./09_No Joke.png": 309,
	"./10_Not U.png": 4531,
	"./11_Not yet Pizza.png": 8999,
	"./12_Reveal.png": 3640,
	"./13_Times change.png": 1994,
	"./14_Transparent.png": 4235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9084;